<template>
  <v-snackbar :value="snackbar" :color="color||'primary'" bottom :timeout="3000">{{ text }}</v-snackbar>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["text","color"],
  data() {
    return {};
  },
  computed: mapState({
    snackbar: state => state.snackbar
  })
};
</script>
